import React from 'react';
import ComingSoon from '../common/ComingSoon';

function Settings() {
  return <ComingSoon title="Settings" />;
}

export default Settings;
